






































































import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator';
import auth from '@/services/auth.service';
import storage from '@/services/local-storage.service';
import cookies from '@/services/cookies.service';
import axios from 'axios';
import jwtDecode from 'jwt-decode';
import {Mutation} from "vuex-class";

@Component({})
export default class Login extends Vue {
    username: string = '';
    password: string = '';
    rememberMe = true;

    loginControls = true;
    isBusy = false;
    statusMessage = '';
    languages = [
        {id: 'rs', text: 'Srpski', flag: 'serbia.png'},
        {id: 'tr', text: 'Türk', flag: 'turkey.png'}
    ];
    languagesSelectOptions = {
        templateResult: this.renderLanguage,
        templateSelection: this.renderLanguage
    };
    selectedLanguage = storage.get('language') || 'rs';
    @Mutation setLoggedUser;
    @Mutation setTenantName;
    @Mutation setAvatar;
    @Mutation setPermissions;
    @Mutation setSuperAdmin;

    @Watch('selectedLanguage') onLanguageChanged(language: string) {
        this.$i18n.locale = language;
    }

    async login() {
        try {
            this.statusMessage = '';
            this.isBusy = true;
            const authResult = await auth.login(this.username, this.password);
            const authData = <any>jwtDecode(authResult.access_token);
            const user = authData['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'];

            this.setLoggedUser(user);
            if (authData.sub == -1) {
                this.setSuperAdmin();
            }
            this.setTenantName(authData.TenantName);
            this.setAvatar(authData['Avatar']);
            this.setPermissions(authData['Permissions']);
            axios.defaults.headers["Authorization"] = `Bearer ${authResult.access_token}`;
            cookies.add('refresh_token', authResult.refresh_token, this.rememberMe ? 45 : null);
            this.$router.push('/');
            this.isBusy = false;
            storage.add('language', this.selectedLanguage);
        } catch (e) {
            this.statusMessage = this.$i18n.t('loginFailed').toString();
            this.isBusy = false;
        }
    }

    private renderLanguage(item: any) {
        return $(`<p style="background: url(/flags/${item.flag}) no-repeat left center; margin-bottom: 0; padding-left: 32px; background-size: 24px">${item.text}</p>`);
    }
}
